<template>
  <path
    d="M12.79 16.9502C15.82 16.5602 18 13.8402 18 10.7902V4.25024C18 3.56024 17.44 3.00024 16.75 3.00024C16.06 3.00024 15.5 3.56024 15.5 4.25024V10.9002C15.5 12.5702 14.37 14.0902 12.73 14.4202C10.48 14.8902 8.5 13.1702 8.5 11.0002V4.25024C8.5 3.56024 7.94 3.00024 7.25 3.00024C6.56 3.00024 6 3.56024 6 4.25024V11.0002C6 14.5702 9.13 17.4202 12.79 16.9502ZM5 20.0002C5 20.5502 5.45 21.0002 6 21.0002H18C18.55 21.0002 19 20.5502 19 20.0002C19 19.4502 18.55 19.0002 18 19.0002H6C5.45 19.0002 5 19.4502 5 20.0002Z"
  />
</template>
